import React, { useEffect, useMemo, useState } from 'react';

import { makeClassNames } from '../../../utils/styles';

import './horizontal-bars.scss';

export interface IHorizontalBars {
  animated?: boolean;
  animationBegin?: string;
  animationDuration?: string;
  colorBar1?: string;
  colorBar2?: string;
  colorEmpty?: string;
  colorStroke?: string;
  valueBar1: number;
  valueBar2: number;
  valueStart?: number;
  widthMax?: number;
  widthMin?: number;
}

const classNames = () =>
  makeClassNames({
    wrapper: 'horizontal-bars__wrapper',
    svg: 'horizontal-bars__svg',
    bar: 'horizontal-bars__bar',
  });

// TODO: Move to a NUMBER UTILS lib?
export const getWidthMinMax = (value: number, min: number, max: number): number => {
  // MIN/MAX range - Should preserve 0% and 100% values from MIN/MAX boundaries
  if (value > max && value < 100) {
    return max;
  }

  if (value < min && value > 0) {
    return min;
  }

  return value;
};

const HorizontalBars = ({
  /* istanbul ignore next: default value */ animated = true,
  /* istanbul ignore next: default value */ animationBegin = '0.5s',
  /* istanbul ignore next: default value */ animationDuration = '1.0s',
  /* istanbul ignore next: default value */ colorBar1 = '#051045',
  /* istanbul ignore next: default value */ colorBar2 = '#69708f',
  /* istanbul ignore next: default value */ colorEmpty = '#d6d6d6',
  /* istanbul ignore next: default value */ colorStroke = '#ffffff',
  /* istanbul ignore next: default value */ valueBar1 = 0,
  /* istanbul ignore next: default value */ valueBar2 = 0,
  /* istanbul ignore next: default value */ valueStart = 50,
  /* istanbul ignore next: default value */ widthMax = 100,
  /* istanbul ignore next: default value */ widthMin = 0,
}: IHorizontalBars) => {
  const cn = classNames();

  const [width, setWidth] = useState(valueStart);

  const total: number = valueBar1 + valueBar2;

  useEffect(() => {
    setWidth(total > 0 ? Math.round((valueBar1 / total) * 100) : 0);
  }, [total, valueBar1]);

  const gottenWidthMinMax = useMemo(() => getWidthMinMax(width, widthMin, widthMax), [width, widthMin, widthMax]);

  return (
    <div
      className={cn.wrapper}
      style={{
        backgroundColor: `${total > 0 ? colorBar2 : colorEmpty}`,
        border: `2px solid ${colorStroke}`,
      }}
    >
      <svg className={cn.svg} xmlns="http://www.w3.org/2000/svg">
        {total === 0 && <rect width="4" height="8" x="50%" y="0" transform="translate(-2, 0)" fill={colorStroke} />}
        {total !== 0 && (
          <rect
            className={cn.bar}
            width={`${gottenWidthMinMax}%`}
            fill={colorBar1}
            stroke={colorStroke}
            rx="6"
            style={{ transition: animated ? `width ${animationDuration} ${animationBegin}` : undefined }}
          />
        )}
      </svg>
    </div>
  );
};

export default HorizontalBars;
